import { render, staticRenderFns } from "./base-access.vue?vue&type=template&id=664f327a&scoped=true&lang=pug&"
import script from "./base-access.vue?vue&type=script&lang=ts&"
export * from "./base-access.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f327a",
  null
  
)

export default component.exports